import React, { useContext } from "react"
import { graphql } from "gatsby"
import PropTypes from "prop-types"
import propTypes from "@styled-system/prop-types"
import { ThemeContext } from "styled-components"

import Image from "../utils/Image"

import Box from "../atoms/Box"
import Modal from "./Modal"

const Popup = ({
  id,
  popupId,
  children,
  backgroundImageMobile,
  backgroundImageDesktop,
  theme,
  bg,
  overlayOpacity,
  modal,
  modalProps,
  popup,
  zIndex,
  buttons,
  ...rest
}) => {
  const background = `background.${bg}`
  const { breakpoints } = useContext(ThemeContext)

  let images
  if (backgroundImageMobile && backgroundImageDesktop) {
    const breakpointTablet = parseInt(breakpoints.md)
    images = [
      { image: backgroundImageDesktop },
      {
        image: backgroundImageMobile,
        media: `(max-width: ${breakpointTablet}px)`,
      },
    ]
  }

  let image
  if (images) {
    image = (
      <Image
        // alternativeText={backgroundImageDesktop.alternativeText}
        images={images}
        style={{ position: "static" }}
      />
    )
  } else if (backgroundImageDesktop) {
    image = <Image {...backgroundImageDesktop} style={{ position: "static" }} />
  } else if (backgroundImageMobile) {
    image = <Image {...backgroundImageMobile} style={{ position: "static" }} />
  }

  return (
    <Modal
      id={id}
      bg={bg}
      theme={theme}
      overlayOpacity={overlayOpacity}
      {...modal}
      {...modalProps}
    >
      <Box
        as="section"
        id={popupId || id}
        position="relative"
        zIndex={zIndex}
        overflowY="auto"
        maxHeight="80vh"
        {...rest}
      >
        {image && (
          <>
            <Box
              position="absolute"
              zIndex={-1}
              top="0"
              right="0"
              bottom="0"
              left="0"
              bg={background}
              overflow="hidden"
            >
              {image}
            </Box>
            <Box
              position="absolute"
              zIndex={0}
              top="0"
              right="0"
              bottom="0"
              left="0"
              bg={background}
              opacity={overlayOpacity || 0}
            />
          </>
        )}

        <Box margin="0px auto">{children}</Box>
      </Box>
    </Modal>
  )
}

Popup.defaultProps = {
  theme: "default",
}

Popup.strapiProps = {
  theme: PropTypes.oneOf(["default", "light", "dark", "highlight"]).isRequired,
  bg: PropTypes.number.isRequired,
  backgroundImageMobile: PropTypes.object,
  backgroundImageDesktop: PropTypes.object,
  overlayOpacity: PropTypes.number,
}

Popup.propTypes = {
  children: PropTypes.node.isRequired,
  ...propTypes.color,
  ...Popup.strapiProps,
}

export default Popup

export const query = graphql`
  fragment Popup on STRAPI__COMPONENT_ATOMS_POPUP {
    strapi_id
    bg
    theme
    backgroundImageMobile {
      ...ImageWithFullWidthLayout
    }
    backgroundImageDesktop {
      ...ImageWithFullWidthLayout
    }
    overlayOpacity
    buttons {
      ...Button
    }
    timerDelay {
      customSize
      sizeSelections
    }
  }
`
